import React, { useState, useRef, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import api from '../../service/api';
import CreateSupplier from '../Supplier/create';
import CreateExpenseCategory from '../ExpenseCategory/create';
import InputDecimal from '../../components/InputDecimal';

export default function UpdateExpense(props){
    let emptyExpense = {
        code: null,
        description: '',
        truck: null,
        due_date: '',
        purchase_date: '',
        amount: null,
        payment_date: null,
        supplier: null,
        category: null
    };

    let {
        visible,
        handleCancel,
        onUpdate,
        travel,
        truck,
        code
    } = props;

    const [expense, setExpense] = useState(emptyExpense);
    const [trucks, setTrucks] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [categories, setCategories] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [showCreateSupplier, setShowCreateSupplier] = useState(false);
    const [showCreateCategory, setShowCreateCategory] = useState(false);

    const toast = useRef(null);

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || (e.value) || '';
        let _expense = { ...expense };
        _expense[`${name}`] = val;

        setExpense(_expense);
    }

    const listByCode = () => {
        api().get('expense/' + code).then(response => {
            if(response.status === 200 && response.data.result){
                setExpense(response.data.data);
            }
        });
    }

    const listTrucks = () => {
        api().get('truck/list').then(response => {
            if(response.status === 200 && response.data.result){
                setTrucks(response.data.data);
            }
        });
    }

    const listSuppliers = (defaultValue = null) => {
        api().get('supplier/list').then(response => {
            if(response.status === 200 && response.data.result){
                setSuppliers(response.data.data);
                if(defaultValue) onInputChange({ value: defaultValue }, 'supplier');
            }
        });
    }

    const listCategories = (defaultValue = null) => {
        api().get('expensecategory/list').then(response => {
            if(response.status === 200 && response.data.result){
                setCategories(response.data.data);
                if(defaultValue) onInputChange({ value: defaultValue }, 'category');
            }
        });
    }

    const onHide = () => {
        setExpense({...emptyExpense});
        handleCancel();
    }

    useEffect(() => {
        if(!code) return onHide();

        listByCode();
        listTrucks();
        listSuppliers();
        listCategories();
    }, [visible]);

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={visible} style={{ width: '450px' }} header="Alterar Despesa" modal className="p-fluid" footer={() => {
                return(
                    <>
                        <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={onHide} />
                        <Button label="Salvar" onClick={() => {
                            if(!expense.amount
                                || !expense.description || !expense.purchase_date)
                                    return setSubmitted(true);
                            
                            setSubmitted(false);
                            setDisabled(true);
                            var _expense = {...expense};
                    
                            _expense['purchase_date'] = (new Date(_expense['purchase_date'])).getTime();
                            if(_expense['due_date']) _expense['due_date'] = (new Date(_expense['due_date'])).getTime();

                            if(travel) _expense['travel'] = travel;
                            if(truck) _expense['truck'] = truck;
                    
                            api().post('/expense/update', _expense).then(response => {
                                setExpense({...emptyExpense});
                                setDisabled(false);
                                if(response.status === 200 && response.data.result){
                                    toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                                    if(typeof onUpdate === 'function')
                                        onUpdate();
                                } else {
                                    toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                                    setDisabled(false);
                                }
                            });

                        }} loading={disabled} icon="pi pi-check" className="p-button-text"  />
                    </>
                );
            }} onHide={onHide}>
                <CreateSupplier visible={showCreateSupplier} handleCancel={() => {
                    setShowCreateSupplier(false);
                }} onUpdate={response => {
                    setShowCreateSupplier(false);
                    if(response.data)
                        listSuppliers(response.data);
                }} />
                <CreateExpenseCategory visible={showCreateCategory} handleCancel={() => {
                    setShowCreateCategory(false);
                }} onUpdate={response => {
                    setShowCreateCategory(false);
                    if(response.data)
                        listCategories(response.data);
                }} />
                
                <div className='formgrid grid'>
                    <div className="field col">
                        <label htmlFor="description">Descrição</label>
                        <InputText disabled={disabled} id="description" required autoFocus  value={expense.description}  onChange={(e) => onInputChange(e, 'description')} />
                        {submitted && !expense.description && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                    </div>
                </div>
                <div className='formgrid grid'>
                    <div className="field col">
                        <label htmlFor='supplier'>Fornecedor (Opcional)</label>
                        <div style={{ display: 'flex' }}>
                            <Dropdown disabled={disabled} value={expense.supplier} style={{ width: '100%' }} showClear emptyMessage='Nenhum registro encontrado'  id="supplier" options={suppliers} onChange={(e) => onInputChange(e, 'supplier')} optionLabel="name" optionValue='code' placeholder="Selecione o fornecedor" />
                            <Button disabled={disabled} onClick={() => {
                                setShowCreateSupplier(true);
                            }} className='p-button-text' icon='pi pi-plus' />
                        </div>
                        
                    </div>
                </div>
                <div className='formgrid grid'>
                    <div className="field col">
                        <label htmlFor='supplier'>Categoria (Opcional)</label>
                        <div style={{ display: 'flex' }}>
                            <Dropdown disabled={disabled} value={expense.category} style={{ width: '100%' }} showClear emptyMessage='Nenhum registro encontrado'  id="category" options={categories} onChange={(e) => onInputChange(e, 'category')} optionLabel="description" optionValue='code' placeholder="Selecione uma categoria" />
                            <Button disabled={disabled} onClick={() => {
                                setShowCreateCategory(true);
                            }} className='p-button-text' icon='pi pi-plus' />
                        </div>
                        
                    </div>
                </div>
                
                <div className='formgrid grid'>
                    <div className="field col">
                        <label htmlFor="due_date">Vencimento</label>
                        <Calendar disabled={disabled} id="due_date" dateFormat="dd/mm/yy" locale='pt-br' value={expense.due_date ? new Date(expense.due_date) : null} onChange={(e) => onInputChange(e, 'due_date')} showIcon />
                        {submitted && !expense.due_date && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}

                    </div>
                    <div className="field col">
                        <label htmlFor="purchase_date">Data da Compra </label>
                        <Calendar disabled={disabled} id="purchase_date" dateFormat="dd/mm/yy" locale='pt-br' value={new Date(expense.purchase_date)} onChange={(e) => onInputChange(e, 'purchase_date')} showIcon />
                        {submitted && !expense.purchase_date && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                    </div>
                </div>
                <div className="formgrid grid">
                    <div className="field col">
                        <label htmlFor="payment_date">Data de Pagamento</label>
                        <Calendar disabled={disabled} id="payment_date" dateFormat="dd/mm/yy" locale='pt-br' value={expense.payment_date ? new Date(expense.payment_date) : null} onChange={(e) => onInputChange(e, 'payment_date')} showIcon />
                        {submitted && !expense.payment_date && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                    </div>
                </div>
                <div className="formgrid grid">
                    <div className="field col">
                        <label htmlFor="amount">Valor Total</label>
                        <InputDecimal disabled={disabled} id="amount" value={expense.amount} mode='currency' onChange={(e) => onInputChange(e, 'amount')} />
                        {submitted && !expense.amount && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                    </div>
                </div>
                {!travel ? (
                    <div className='formgrid grid'>
                        <div className="field col">
                            <label htmlFor='truck'>Caminhão (Opcional)</label>
                            <Dropdown disabled={disabled} value={expense.truck} showClear  id="truck" options={trucks} onChange={(e) => onInputChange(e, 'truck')} optionLabel="plate" optionValue='code' placeholder="Selecione o caminhão" />
                        </div>
                    </div>
                ) : ''}
            </Dialog>
        </>
        
    );
}